import { useCallback } from 'react';

import qs from 'qs';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useCancelableNavigate } from '#src/app/shared/hooks/navigate';
import type { ShareChannel } from '#src/app/shared/hooks/share';

import { usePromoteOrShareActionUrls } from '../../../usePromoteOrShareActionUrls';

const generateRedirectUrl = (shareButtonUrl: string, channel: ShareChannel) => {
	const [baseUrl, queryString] = shareButtonUrl.split('?');

	const queryParams = queryString ? Object.fromEntries(new URLSearchParams(queryString)) : {};

	return `${baseUrl}${qs.stringify(
		{
			...queryParams,
			slide_up_source: channel,
		},
		{ addQueryPrefix: true },
	)}`;
};

export function useRedirect() {
	const {
		data: { shareButtonUrl },
	} = usePromoteOrShareActionUrls();

	const {
		userAgent: { isWebview },
	} = useUtilityContext();

	const { cancelableNavigate } = useCancelableNavigate();

	return useCallback(
		(channel: ShareChannel) => {
			// webviews do not allow opening in new tab, which most share actions attempt to do
			// instead they attempt to open in the current tab, which if overridden by this redirect
			// so this disables the redirect in order to be able to share
			if (isWebview) return;

			const redirectUrl = generateRedirectUrl(shareButtonUrl, channel);

			if (channel === 'copy') {
				setTimeout(() => {
					cancelableNavigate({
						eventName: 'shareChannelSelectedRedirect',
						eventConfig: {
							selectedChannel: channel,
						},
						redirectUrl,
					});
				}, 2000);
				return;
			}

			cancelableNavigate({
				eventName: 'shareChannelSelectedRedirect',
				eventConfig: {
					selectedChannel: channel,
				},
				redirectUrl,
			});
		},
		[isWebview, cancelableNavigate, shareButtonUrl],
	);
}
